import Header from "../components/Header";
import Footer from "../components/Footer";
import Hero from "../components/sections/Hero";
import Mission from "../components/sections/WhoWeAre";
import FCNRHighlight from "../components/sections/FCNRHighlight";
import WhyUs from "../components/sections/Insights";
import Solutions from "../components/sections/OurServices";
import FAQ from "../components/sections/FAQ";
import LeadForm from "../components/sections/LeadForm";
import FCNRRates from "../components/sections/FCNRRates";
import IndependenceDayBanner from "../components/IndependenceDayBanner";
import SiteBackground from "../components/decorations/SiteBackground";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen relative">
      <SiteBackground />
      <IndependenceDayBanner />
      <Header />
      <main>
        <Hero />
        <FCNRRates />
        <Mission />
        <FCNRHighlight />
        <Solutions />
        <WhyUs />
        <FAQ />
        <LeadForm />
      </main>
      <Footer />
    </div>
  );
}
